<template>
  <div class="form-row">
    <div class="col-12">
      <div class="form-row">
        <div class="form-group col-4">
          <input
            type="text"
            id="product"
            class="form-control"
            v-model="client.product"
            :disabled="!canEditMainFields()"
          />
          <label for="product">Product</label>
        </div>
        <div class="form-group col-4">
          <input
            type="text"
            id="subDomain"
            class="form-control"
            v-model="client.subDomain"
            :disabled="!canEditMainFields()"
          />
          <label for="subDomain">Sub Domain</label>
        </div>
        <div class="form-group col-4">
          <input
            type="text"
            id="companyName"
            class="form-control"
            v-model="client.companyName"
          />
          <label for="companyName">Company Name</label>
        </div>
      </div>
      <div class="form-row">
        <div class="form-group col-6">
          <input
            type="text"
            id="abnNumber"
            class="form-control"
            v-model="client.abnNumber"
          />
          <label for="abnNumber">ABN Number</label>
        </div>
        <div class="form-group col-6">
          <input
            type="email"
            id="accountEmail"
            class="form-control"
            v-model="client.accountEmail"
          />
          <div class="error" v-if="!isEmailValid()">Invalid Email</div>
          <label for="accountEmail">Account Email</label>
        </div>
      </div>
      <div class="form-row">
        <div class="form-group col-6">
          <input
            type="text"
            id="vendorNumber"
            class="form-control"
            v-model="client.vendorNumber"
          />
          <label for="vendorNumber">Vendor Number</label>
        </div>
        <div class="form-group col-6">
          <input
            type="email"
            id="workflowNumber"
            class="form-control"
            v-model="client.workflowNumber"
          />
          <label for="workflowNumber">Workflow Number</label>
        </div>
      </div>
      <h3 class="section-heading">Billing Address</h3>
      <div class="form-row">
        <div class="form-group col-2">
          <input
            type="text"
            id="buildingName"
            class="form-control"
            v-model="client.billingAddress.buildingName"
          />
          <label for="buildingName">Flat/Unit/Apt</label>
        </div>
        <div class="form-group col-2">
          <input
            type="text"
            id="thoroughfareNumber"
            class="form-control"
            v-model="client.billingAddress.thoroughfareNumber"
          />
          <label for="thoroughfareNumber">Sreet Number</label>
        </div>
        <div class="form-group col-8">
          <input
            type="text"
            id="thoroughfareName"
            class="form-control"
            v-model="client.billingAddress.thoroughfareName"
          />
          <label for="thoroughfareName">Street Name</label>
        </div>
      </div>
      <div class="form-row">
        <div class="form-group col-6">
          <input
            type="text"
            id="localityName"
            class="form-control"
            v-model="client.billingAddress.localityName"
          />
          <label for="localityName">Suburb</label>
        </div>
        <div class="form-group col-3">
          <input
            type="text"
            id="postalCodeNumber"
            class="form-control"
            v-model="client.billingAddress.postalCodeNumber"
          />
          <label for="postalCodeNumber">Postcode</label>
        </div>
        <div class="form-group col-3">
          <select
            id="administrativeAreaName"
            class="form-control"
            v-model="client.billingAddress.administrativeAreaName"
          >
            <option
              v-for="state in australianStates"
              :key="state"
              :value="state"
              >{{ state }}</option
            >
          </select>
          <label for="administrativeAreaName">State</label>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="form-row">
        <div class="form-group col-6">
          <input
            type="text"
            id="emailFromName"
            class="form-control"
            v-model="client.emailFromName"
          />
          <label for="emailFromName">Email Sent From Name</label>
        </div>
      </div>
    </div>
    <div class="col-12">
      <h3 class="section-heading">Accounts Email</h3>
      <div class="form-row">
        <div class="form-group col-6">
          <input
            type="text"
            id="emailRecipients"
            class="form-control"
            v-model="client.ordersReport.recipients"
          />
          <div class="error" v-if="!isEmailListValid()">Invalid Email List</div>
          <label for="emailRecipients">Recipients (comma separated)</label>
        </div>
        <div class="form-group col-6">
          <div>
            <label>Repeat on</label><br />
            <div class="c__checkbox inline">
              <input
                id="Mon"
                type="radio"
                value="Mon"
                v-model="client.ordersReport.recurrencePattern.weekday"
              />
              <label class="round" for="Mon">Mon</label>
            </div>
            <div class="c__checkbox inline">
              <input
                id="Tue"
                type="radio"
                value="Tue"
                v-model="client.ordersReport.recurrencePattern.weekday"
              />
              <label class="round" for="Tue">Tue</label>
            </div>
            <div class="c__checkbox inline">
              <input
                id="Wed"
                type="radio"
                value="Wed"
                v-model="client.ordersReport.recurrencePattern.weekday"
              />
              <label class="round" for="Wed">Wed</label>
            </div>
            <div class="c__checkbox inline">
              <input
                id="Thu"
                type="radio"
                value="Thu"
                v-model="client.ordersReport.recurrencePattern.weekday"
              />
              <label class="round" for="Thu">Thu</label>
            </div>
            <div class="c__checkbox inline">
              <input
                id="Fri"
                type="radio"
                value="Fri"
                v-model="client.ordersReport.recurrencePattern.weekday"
              />
              <label class="round" for="Fri">Fri</label>
            </div>
            <div class="c__checkbox inline">
              <input
                id="Sat"
                type="radio"
                value="Sat"
                v-model="client.ordersReport.recurrencePattern.weekday"
              />
              <label class="round" for="Sat">Sat</label>
            </div>
            <div class="c__checkbox inline">
              <input
                id="Sun"
                type="radio"
                value="Sun"
                v-model="client.ordersReport.recurrencePattern.weekday"
              />
              <label class="round" for="Sun">Sun</label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-6">
      <h3 class="section-heading">Conversion Data Source</h3>
      <div class="form-row">
        <div class="col-6">
          <div class="form-check form-check-inline" style="margin-right: 20px;">
            <input
              type="radio"
              id="google-analytics"
              class="form-check-input"
              v-bind:value="'GA'"
              v-model="client.clientIntegration.campaignStatSource"
            />
            <label class="form-check-label">Google Analytics</label>
          </div>
          <div class="form-check form-check-inline">
            <input
              type="radio"
              id="loopa"
              class="form-check-input"
              v-bind:value="'Loopa'"
              v-model="client.clientIntegration.campaignStatSource"
            />
            <label class="form-check-label">Loopa</label>
          </div>
        </div>
      </div>
    </div>
    <div class="col-6">
      <h3 class="section-heading mb-0">Authorized Domains</h3>
      <div class="form-group" style="position: relative;">
        <div
          class="c__info"
          style="position: absolute;right: 12px;bottom: 8px;"
        >
          <div class="c__tooltip_container">
            <icon-info></icon-info>
            <div class="c__tooltip">
                Domains registered here will be used to validate URLs entered in the agent extend landing page URL field under the campaign booking form.
            </div>
          </div>
        </div>
        <input
          type="text"
          id="domains"
          class="form-control"
          placeholder="example.com, agents.example.com"
          v-model="client.clientDomains"
        />
        <div class="error" v-if="!isDomainsValid()">Invalid Domain</div>
        <label for="domains" style="font-size: 12px;"
          >Comma separated domains. To allow all subdomains under a parent
          domain, you may use an asterisk (*) e.g. *.example.com.</label
        >
      </div>
    </div>
  </div>
</template>

<script>
import IconInfo from '../../../assets/icons/icon-info.vue';

export default {
  name: 'clientDetails',
  props: [
    'client',
    'canEditMainFields',
    'isEmailValid',
    'isEmailListValid',
    'australianStates',
    'isDomainsValid'
  ],
  components: {
    IconInfo,
  },
};
</script>
